import { render, staticRenderFns } from "./CommunityList.vue?vue&type=template&id=a06bc31c&scoped=true"
import script from "./CommunityList.vue?vue&type=script&lang=js"
export * from "./CommunityList.vue?vue&type=script&lang=js"
import style0 from "./CommunityList.vue?vue&type=style&index=0&id=a06bc31c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06bc31c",
  null
  
)

export default component.exports